<!--
 * @Description:合作伙伴页面
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-04-20 17:09:40
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @mask="showMask"
        @fetch="getList"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosLbuPartnerManage"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="name" label="合作伙伴名称">
              <a-input v-model:value="queryForm.name" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="starGrade" label="评级">
              <a-select
                v-model:value="queryForm.starGrade"
                allowClear
                placeholder="请选择"
                :options="dataConfig.starGrade"
              />
            </dc-form-item>
            <dc-form-item name="contactName" label="联系人">
              <a-input v-model:value="queryForm.contactName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="property" label="性质">
              <ParamCodesSelect :options="paramCodeData.zbu_partner_nature_lbu" v-model:value="queryForm.property" />
            </dc-form-item>
            <dc-form-item name="mainCustomer" label="主要客群">
              <ParamCodesSelect :options="paramCodeData.zbu_main_customers_lbu" v-model:value="queryForm.mainCustomer" />
            </dc-form-item>
            <dc-form-item name="activityType" label="市场活动类型">
              <ParamCodesSelect :options="paramCodeData.zbu_campaign_type_lbu" v-model:value="queryForm.activityType" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'areaId'">
            <CustomerArea type="text" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="handleFollow(record)" v-permission="'lbu_partner_maintain_add_btn'"
                >维护关系</a-button
              >
              <a-button type="link" @click="handleActivity(record)" v-permission="'lbu_partner_activity_add_btn'"
                >新增活动</a-button
              >
              <a-button type="link" @click="handleEdit(record)" v-permission="'lbu_partner_edit_btn'">编辑</a-button>
              <a-button type="link" @click="handleDelete(record)" v-permission="'lbu_partner_del_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd()" v-permission="'lbu_partner_add_btn'">新增</a-button>
          <ExportButton appId="cos_zbu" taskType="103" :search="queryForm" v-permission="'lbu_partner_export_btn'"
            >导出</ExportButton
          >
        </template>
      </cos-table>
      <partnerFollowRecordFrom ref="partnerFollowFromRef" @success="success" />
      <partnerActivityFrom ref="partnerActivityFromRef" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import { partnerGet, partnerDelete, partnerDetail } from '@/api/marketing/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import CustomerArea from '@/components/CustomerArea'
import { useRouter } from 'vue-router'
import { listByParamCodes } from '@/api/common'
import Modal from '@/hooks/modalType'
import partnerFollowRecordFrom from './components/partnerFollowRecordFrom.vue'
import partnerActivityFrom from './components/partnerActivityFrom.vue'
import { DcMessage } from '@dc-platform/dc-components'
import type { PartnerManageList } from '@/typings/api/marketingManage'
const router = useRouter()
const tableRef = ref()
const partnerFollowFromRef = ref()
const partnerActivityFromRef = ref()
const queryForm = reactive({})
const paramCodeData = reactive<{
  zbu_grade_lbu: []
  zbu_partner_nature_lbu: []
  zbu_main_customers_lbu: []
  zbu_campaign_type_lbu: []
  zbu_partner_role_lbu: []
  zbu_partner_area_lbu: []
}>({
  zbu_grade_lbu: [], // 评级
  zbu_partner_nature_lbu: [], // 合作伙伴性质
  zbu_main_customers_lbu: [], // 主要客群
  zbu_campaign_type_lbu: [], // 市场活动类型
  zbu_partner_role_lbu: [],
  zbu_partner_area_lbu: []
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_grade_lbu',
      'zbu_partner_nature_lbu',
      'zbu_main_customers_lbu',
      'zbu_campaign_type_lbu',
      'zbu_partner_role_lbu',
      'zbu_partner_area_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handleDelete = (row: PartnerManageList) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerDelete({
        id: row.id
      }).then((res) => {
        DcMessage.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const getList = (params: object, callBack: (res: any) => void) => {
  partnerGet({
    ...params,
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
// 新增编辑函数
const handleAdd = () => {
  router.push({
    path: '/lbu/partnerManage/add'
  })
}
// 获取掩码信息
const showMask = (record: PartnerManageList, callBack: (res: any) => void) => {
  partnerDetail({
    id: record.id,
    isForUpdate: true
  }).then((res) => {
    if (res.data?.partnerContact) {
      callBack({
        ...res.data.partnerContact,
        contactName: res.data.partnerContact.name
      })
    } else {
      callBack({})
    }
  })
}
const handleEdit = (row: PartnerManageList) => {
  router.push({
    path: '/lbu/partnerManage/edit',
    query: {
      id: row.id
    }
  })
}
// 维护关系
const handleFollow = (row: PartnerManageList) => {
  partnerFollowFromRef.value.toggle({
    partnerName: row.name,
    partnerId: row.id
  })
}
// 添加活动
const handleActivity = (row: PartnerManageList) => {
  partnerActivityFromRef.value.toggle({
    partnerName: row.name,
    partnerId: row.id
  })
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  {
    title: '合作伙伴名称',
    dataIndex: 'name',
    cosType: 'link',
    path: '/lbu/partnerManage/view',
    query: ['id', 'name'],
    fixed: 'left',
    width: 200
  },
  {
    title: '合作伙伴简介',
    dataIndex: 'intro'
  },
  {
    title: '评级',
    dataIndex: 'starGrade',
    dicData: dataConfig.starGrade,
    filterNoVal: true
  },
  {
    title: '知名度',
    dataIndex: 'popularityDegree',
    filterNoVal: true
  },
  {
    title: '契合度',
    dataIndex: 'agreementDegree',
    filterNoVal: true
  },
  {
    title: '关系',
    dataIndex: 'relationDegree',
    filterNoVal: true
  },
  {
    title: 'Base地',
    dataIndex: 'areaId'
  },
  {
    title: '合作伙伴区域',
    dataIndex: 'regionId',
    dicData: paramCodeData.zbu_partner_area_lbu,
    filterNoVal: true
  },
  {
    title: '性质',
    dataIndex: 'property',
    dicData: paramCodeData.zbu_partner_nature_lbu,
    filterNoVal: true
  },
  {
    title: '主要客群',
    dataIndex: 'mainCustomers',
    dicData: paramCodeData.zbu_main_customers_lbu
  },
  {
    title: '市场活动类型',
    dataIndex: 'activityTypes',
    dicData: paramCodeData.zbu_campaign_type_lbu
  },
  {
    title: '网站/公众号',
    dataIndex: 'webSite'
  },
  {
    title: '联系人',
    dataIndex: 'contactName',
    cosType: 'mask'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum,
    filterNoVal: true
  },
  {
    title: '角色',
    dataIndex: 'role',
    dicData: paramCodeData.zbu_partner_role_lbu,
    filterNoVal: true
  },
  {
    title: '手机',
    dataIndex: 'mobile',
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: 'wechat',
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq',
    cosType: 'mask'
  },
  {
    title: '最新维护时间',
    dataIndex: 'recordCreateTime',
    width: 190
  },
  {
    title: '具体内容',
    dataIndex: 'content'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 240,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuPartnerManage' }
</script>
